import React, { Component } from 'react'
import ChangePassword from './view'
import { connect } from 'react-redux'

import { req } from '../../util'

import { toggleLoading, toggleSnackBar, unSetUserInfo } from '../../redux/actions'

const mapDispatchToProps = dispatch => ({
    toggleLoading: () => dispatch(toggleLoading()),
    toggleSnackBar: msg => dispatch(toggleSnackBar(msg)),
    unSetUserInfo: () => dispatch(unSetUserInfo())
})
class index extends Component {
    constructor(props) {
        super(props)
        this.state = {
            oldPassword: '',
            newPassword: '',
            ReTypeNewPassword: ''
        }
    }

    onTextChange = (e) => this.setState({ [e.target.name]: e.target.value })


    onSubmit = (evt) => {
        evt.preventDefault()
        evt.preventDefault()
        let { oldPassword, newPassword, ReTypeNewPassword } = this.state;
        let { toggleLoading, toggleSnackBar, unSetUserInfo, history } = this.props;
        if (newPassword !== ReTypeNewPassword) {
            toggleSnackBar("كلمة المرور غير متطابقة")
            return
        }
        toggleLoading()
        req('POST', 'auth/users/changepassword', { oldPassword, password: newPassword }).then(res => {
            let { success, msg } = res;
            if (success) {
                toggleSnackBar("تم تغيير كلمة المرور بنجاح")
                unSetUserInfo()
                history.push("/login")
            } else {
                toggleSnackBar(msg)
            }
            toggleLoading()
            return
        }).catch(e => {
            toggleLoading()
            toggleSnackBar('هنالك مشكلة في الشبكة !!')
            console.error(e)
        })
    }
    render() {
        return (
            <ChangePassword onSubmit={this.onSubmit} onTextChange={this.onTextChange} {...this.state} />
        )
    }
}


export default connect(null, mapDispatchToProps)(index)